export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineTemp.worker.f7ba95e4a778d34008cd-625.worker.js");
}
